/**
 * Компонент экрана приветствия
 */

import styles from './WelcomeScreen.module.css';
import { QuickQuestions } from '../QuickQuestions';
import { SuggestedQuestion } from '@/types/message.types';
import { LarteLogo } from '../Logo';

/**
 * Пропсы компонента WelcomeScreen
 */
interface WelcomeScreenProps {
  /** Приветственное сообщение */
  message: string;
  /** Быстрые вопросы */
  questions: SuggestedQuestion[];
  /** Колбек при клике на вопрос */
  onQuestionClick: (question: string) => void;
}

/**
 * Экран приветствия
 * 
 * @description Отображается при первом открытии виджета
 */
export function WelcomeScreen({ message, questions, onQuestionClick }: WelcomeScreenProps) {
  return (
    <div className={styles.welcomeScreen}>
      {/* Логотип */}
      <div className={styles.avatar}>
        <LarteLogo size={80} color="var(--accent)" />
      </div>

      {/* Приветственное сообщение */}
      <div className={styles.message}>
        <p>{message}</p>
      </div>

      {/* Быстрые вопросы */}
      {questions.length > 0 && (
        <QuickQuestions questions={questions} onQuestionClick={onQuestionClick} />
      )}
    </div>
  );
}

